import { render } from "./subAccCreate.vue?vue&type=template&id=3b3d8324"
import script from "./subAccCreate.vue?vue&type=script&lang=js"
export * from "./subAccCreate.vue?vue&type=script&lang=js"

import "./subAccCreate.vue?vue&type=style&index=0&id=3b3d8324&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__